<nav class="patient-nav-group">
  <button class="patient-nav-item"
          type="button"
          mat-button
          matTooltip="Go to the full list of patients for your facility"
          matTooltipPosition="below"
          (click)="backToPatientsList.emit()">
    <mat-icon>
      personal_injury
    </mat-icon>
    <span>
      Facility Patients
    </span>
  </button>
  <div class="patient-nav-divider"></div>
  <button class="patient-nav-item"
          type="button"
          mat-button
          matTooltip="Return to this patient's overview — documents, studies, and sharing"
          matTooltipPosition="below"
          (click)="backToPatientOverview.emit()">
    <mat-icon>
      home
    </mat-icon>
    <span>
      Patient Overview
    </span>
  </button>
  <div class="patient-nav-divider"></div>
  <button class="patient-nav-item"
          type="button"
          mat-button
          matTooltip="Return to the main application home screen"
          matTooltipPosition="below"
          (click)="backToHome.emit()">
    <mat-icon>
      menu
    </mat-icon>
    <span>
      Back to Home
    </span>
  </button>
</nav>
